export default __webpack_public_path__ + "static/media/miscellaneous20.9135a50b.png";